// STYLE-K tokens (design/04-the-card.md). The card is 432×540 layout px, exported at 2.5× to 1080×1350 (4:5).
export const T = {
  cream: '#FFF3E0', creamDot: '#F3E0C2', mint: '#CFEBDD', mintDot: '#B2DCC6',
  wood: '#E0A96D', woodLip: '#EBBC85', woodDark: '#C98E52',
  white: '#FFFFFF', navy: '#1B4FA8', body: '#1F4285', muted: '#6179A8', rule: '#D9E4F5', badge: '#4C7BD0',
  green: '#4CAF50', greenDark: '#3B8E3F', coral: '#F2705B', coralDark: '#D65A46',
  butter: '#FFC53D', butterDark: '#E0A520', pink: '#F0A0B4', sky: '#A9D4EE', sheet: '#EDE3D3',
};
export const SANS = "'Nunito','Varela Round','Arial Rounded MT Bold',system-ui,sans-serif";
export const HAND = "'Caveat','Bradley Hand','Segoe Print',cursive";
export const W = 432;
export const H = 540;
export const EXPORT_SCALE = 2.5;
